module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M6.798 17.672H25.2a1.671 1.671 0 1 1 0 3.344H6.798a1.671 1.671 0 1 1 0-3.344zm5.02 6.692h8.364a1.673 1.673 0 0 1 0 3.346h-8.364a1.673 1.673 0 0 1 0-3.346zM6.798 4.29H25.2a1.671 1.671 0 1 1 0 3.344H6.798a1.673 1.673 0 0 1 0-3.344z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/marketing-secondary.js
// module id = 1257
// module chunks = 14